import React from 'react'

const CamposProducto = ({ state, handleInputChangeEnlace, divisas }) => {
  // Función para calcular el precio final con descuento
  const calcularPrecioFinal = () => {
    const precio = parseFloat(state.enlace.precio) || 0
    const descuento = parseFloat(state.enlace.descuento) || 0
    
    if (precio === 0 || descuento === 0) {
      return precio
    }
    
    const descuentoCalculado = precio * (descuento / 100)
    return precio - descuentoCalculado
  }

  return (
    <div className="space-y-4 p-4 bg-emerald-50 rounded-lg border border-emerald-200">
      <h4 className="font-semibold text-emerald-800 flex items-center gap-2">
        <i className="fas fa-shopping-cart"></i>
        Información del Producto
      </h4>
      
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          URL del Producto <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <i className="fas fa-link absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
          <input
            type="url"
            placeholder="https://mi-tienda.com/producto"
            value={state.enlace.url}
            onChange={(e) => handleInputChangeEnlace('url', e.target.value)}
            required
            className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Precio <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <i className="fas fa-dollar-sign absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
            <input
              type="number"
              step="0.01"
              placeholder="99.99"
              value={state.enlace.precio}
              onChange={(e) => handleInputChangeEnlace('precio', e.target.value)}
              required
              className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>
        
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Moneda
          </label>
          <select
            value={state.enlace.divisa}
            onChange={(e) => handleInputChangeEnlace('divisa', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            {divisas.map((divisa) => (
              <option key={divisa.codigo} value={divisa.codigo}>
                {divisa.simbolo} {divisa.nombre}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      {/* Descuento y precio final */}
      {state.enlace.precio && (
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Descuento (%)
            </label>
            <div className="relative">
              <i className="fas fa-percentage absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
              <input
                type="number"
                min="0"
                max="100"
                step="0.01"
                placeholder="0"
                value={state.enlace.descuento}
                onChange={(e) => handleInputChangeEnlace('descuento', e.target.value)}
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>
          
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Precio Final
            </label>
            <div className="relative">
              <i className="fas fa-tag absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
              <input
                type="text"
                value={calcularPrecioFinal().toFixed(2)}
                readOnly
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-700 font-semibold"
              />
            </div>
            {state.enlace.descuento && parseFloat(state.enlace.descuento) > 0 && (
              <div className="flex items-center gap-2 text-sm">
                <span className="text-red-600 font-medium">
                  -{parseFloat(state.enlace.descuento).toFixed(1)}%
                </span>
                <span className="text-gray-500 line-through">
                  {parseFloat(state.enlace.precio).toFixed(2)}
                </span>
              </div>
            )}
          </div>
        </div>
      )}
      
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Stock (opcional)
          </label>
          <div className="relative">
            <i className="fas fa-boxes absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
            <input
              type="number"
              placeholder="100"
              value={state.enlace.stock}
              onChange={(e) => handleInputChangeEnlace('stock', e.target.value)}
              className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>
        
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Categoría (opcional)
          </label>
          <div className="relative">
            <i className="fas fa-tags absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
            <input
              type="text"
              placeholder="Electrónicos, Ropa, etc."
              value={state.enlace.categoria}
              onChange={(e) => handleInputChangeEnlace('categoria', e.target.value)}
              className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>
      </div>
      
      <div className="flex items-center justify-between p-3 bg-emerald-100 rounded-lg">
        <div className="flex items-center gap-3">
          <i className="fas fa-check-circle text-emerald-600"></i>
          <div>
            <p className="text-sm font-medium text-emerald-800">Producto disponible</p>
            <p className="text-xs text-emerald-600">Los clientes podrán ver y comprar este producto</p>
          </div>
        </div>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={state.enlace.disponible}
            onChange={(e) => handleInputChangeEnlace('disponible', e.target.checked)}
            className="sr-only peer"
          />
          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-emerald-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-600"></div>
        </label>
      </div>
    </div>
  )
}

export default CamposProducto 